const FEATURES = [
  {
    icon: 'ri-stack-line',
    title: '全类型分类',
    desc: '纯爱、奇幻、热血、悬疑、搞笑、都市、古风、玄幻、校园、治愈等十余种类型精细整理，一键直达心仪分类。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '每日极速更新',
    desc: '每日追踪 200+ 话更新，热门作品同步汉化，让你永远第一时间看到最新章节。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '永久收藏书签',
    desc: '一次收藏即可建立专属漫画书架，阅读进度自动同步，随时随地继续追更。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净阅读体验',
    desc: '全站无弹窗广告、无恶意跳转，只专注于最纯粹的漫画阅读享受。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '漫友社区互动',
    desc: '每部作品下方都有漫友热评与讨论，看漫画的同时也能找到志同道合的朋友。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          为什么 3000+ 漫迷选择新新漫画
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/20 transition-all text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-[15px] font-bold text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-[13px] leading-relaxed text-foreground-500">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}